module.exports = __webpack_public_path__ + "img/bottom_lightning_mobile.dd4b67d8.png";